<template>

  <main class="ps-page--my-account">
    <div class="ps-breadcrumb">
      <div class="container">
        <ul class="breadcrumb">
          <li v-if="isEnglish()==true"><a href="/#/private">Home</a></li>
          <li v-if="isEnglish()==false"><a href="/#/private">Acceuil</a></li>
          <li>Invitations</li>
        </ul>
      </div>
    </div>
    <section class="ps-section--account">
      <div class="container">
        <div class="row">
          <div class="col-lg-3">
            <div class="ps-section__left">
              <aside class="ps-widget--account-dashboard">
                <div class="ps-widget__header"><img src="../assets/img/users/3.jpg" alt="">
                  <figure>
                    <figcaption>Hello</figcaption>
                    <p><a href="#">{{user_email}}</a></p>
                  </figure>
                </div>
                  <side-menu :lang="lang" :invi_state="invi_state" >  </side-menu>
              </aside>
            </div>
          </div>
          <div class="col-lg-9">
            <div class="ps-section__right">
              <section class="ps-items-listing">
                <div v-if="isEnglish()==true" class="ps-section__actions">
                  <a v-if="caller_role!='Basic'" v-on:click="newModelOpened()" class="ps-btn success" href="#" data-toggle="modal" data-target="#inviteModal">
                    <i  class="icon icon-plus mr-2"> </i>  New invite
                  </a>
                </div>
                  <div v-if="isEnglish()==false" class="ps-section__actions">
                  <a v-if="caller_role!='Basic'" v-on:click="newModelOpened()" class="ps-btn success" href="#" data-toggle="modal" data-target="#inviteModal">
                    <i  class="icon icon-plus mr-2"> </i> Nouvelle invitation
                  </a>
                </div>
                <!--<div class="ps-section__header">
                </div>-->
                <div class="ps-section__content">
                  <div class="table-responsive">
                    <div v-if="granted" class="alert alert-success" role="alert">
                      {{msg}}
                    </div>
                    <div v-if="sent" class="spinner-border" role="status">
                      <span class="visually-hidden"></span>
                    </div>
                    <table class="table ps-table" id="myTable">
                      <thead>
                      <tr>
                        <th>ID</th>
                        <th>Email</th>
                        <th v-if="isEnglish()==true">Company name</th>
                        <th v-if="isEnglish()==false">Nom de la compagnie</th>

                        <th>Role</th>
                        <th v-if="isEnglish()==true">Created_at</th>
                        <th v-if="isEnglish()==false">Date création</th>
                        <th>Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="item in invitees" :key="item.email">
                        <td>{{item.id}}</td>
                        <td><a href="#"><strong>{{item.email}}</strong></a></td>
                        <td>{{item.company_name}}</td>
                        <td>{{item.role}}</td>



                        <td>   {{ date_formatting(item.created_at) }}</td>
                        <td>
                          <div class="dropdown"><a id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="icon-ellipsis"></i></a>
                            <div v-if="isEnglish()==true" class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                              <a v-if="!item.used" class="dropdown-item" v-on:click="greet(item)" data-toggle="modal" data-target="#resendModal" href="#">ReSend</a>
                              <a v-if="!item.used" class="dropdown-item" v-on:click="greet(item)" data-toggle="modal" data-target="#changeroleModal" href="#">Edit</a>
                              <a class="dropdown-item" v-on:click="greet(item)" data-toggle="modal" data-target="#deleteModal" href="#">Delete</a>
                            </div>
                              <div v-if="isEnglish()==false" class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                              <a v-if="!item.used" class="dropdown-item" v-on:click="greet(item)" data-toggle="modal" data-target="#resendModal" href="#">Renvoyer</a>
                              <a v-if="!item.used" class="dropdown-item" v-on:click="greet(item)" data-toggle="modal" data-target="#changeroleModal" href="#">Modifier</a>
                              <a class="dropdown-item" v-on:click="greet(item)" data-toggle="modal" data-target="#deleteModal" href="#">Supprimer</a>
                            </div>
                          </div>
                        </td>
                      </tr>



                      </tbody>
                    </table>
                  </div>
                </div>

              </section>
            </div>
          </div>
        </div>
      </div>
    </section>


    <div class="modal fade" id="inviteModal" tabindex="-1" role="dialog" aria-labelledby="inviteModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <!-- <h5 v-if="isEnglish()==true" class="modal-title" id="inviteModalLabel">Send invite to a new user for registration</h5>
            <h5 v-if="isEnglish()==false" class="modal-title" id="inviteModalLabel">Envoie d'invitation nouvel utilisateurs</h5> -->
            <h5  v-if="failed" style="color:red" class="modal-title" id="inviteModalLabel"> {{ msg }} </h5>
           
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row form-group">
                <div class="col">
                  <!-- <div  v-if="failed" class="alert alert-danger" role="alert">
                    {{ msg }}
                  </div> -->
                  <label v-if="isEnglish()==true">Email of your user</label>
                  <label v-if="isEnglish()==false">Email de votre utilisateur</label>
                  <input type="text" v-model="invitee.email" class="form-control" placeholder="Email here" required>
                </div>
              </div>

              <div v-if="isSuper" class="row form-group">
                <div class="col">
                  <label v-if="isEnglish()==true" for="exampleFormControlSelect1">Select the Company</label>
                   <label v-if="isEnglish()==false" for="exampleFormControlSelect1">Choississez la compagnie</label>
                  <select class="form-control" v-model="invitee.no_company"  v-on:change="onCompanyChange()" required>
                    <option  v-for="company in companies" :key="company.no_company" v-bind:value="company.no_company">  ({{company.no_company}}) {{company.name}}</option>
                  </select>
                </div>
              </div>

             <div class="row form-group">
                  <div class="col">
                    <label v-if="isEnglish()==true" for="exampleFormControlSelect1">Select divisions</label>
                    <label v-if="isEnglish()==false" for="exampleFormControlSelect1">Choisir les divisions</label>
                    <v-select taggable multiple v-model="selected" :options="divisions" :close-on-select="false"/>
                  </div>
             </div>

              <div class="row form-group">
                <div class="col">
                  <label v-if="isEnglish()==true" for="exampleFormControlSelect1">Select Role</label>
                  <label v-if="isEnglish()==false" for="exampleFormControlSelect1">Choisir Role</label>
                  <select class="form-control" v-model="invitee.role" id="exampleFormControlSelect1">
                    <option value="Basic">Basic</option>
                    <option value="Admin"> Admin</option>
                  </select>
                </div>
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button v-if="isEnglish()==true" type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button v-if="isEnglish()==true" type="button" class="btn btn-primary" v-on:click="send_invite()">Send invite</button>
            <button v-if="isEnglish()==false" type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
            <button v-if="isEnglish()==false" type="button" class="btn btn-primary" v-on:click="send_invite()">Envoyer invitation</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="changeroleModal" tabindex="-1" role="dialog" aria-labelledby="changeroleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-if="isEnglish()==true" class="modal-title" id="changeroleModalLabel">Change invite role </h5>
            <h5 v-if="isEnglish()==false" class="modal-title" id="changeroleModalLabel">Changement de role </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row form-group">
                <div class="col">
                  <div  v-if="failed" class="alert alert-danger" role="alert">
                    {{ msg }}
                  </div>
                  <label v-if="isEnglish()==true">Email of your user</label>
                  <label v-if="isEnglish()==false">Email de l'utilisateur</label>
                  <input type="text" v-model="invitee.email" class="form-control" placeholder="Email here" disabled>
                </div>
              </div>

              <div class="row form-group">
                <div class="col">  <div class="form-group">
                  <label for="exampleFormControlSelect1">Company</label>
                  <input type="text" v-model="invitee.company_name" class="form-control" disabled>
                </div></div>
              </div>

              <div class="row form-group">
                <div class="col">
                  <label v-if="isEnglish()==true" for="exampleFormControlSelect1">Select  Role</label>
                  <label v-if="isEnglish()==false" for="exampleFormControlSelect1">Selectionner  Role</label>
                  <select class="form-control" v-model="invitee.role" id="exampleFormControlSelect1">
                    <option value="Basic">Basic</option>
                    <option value="Admin"> Admin</option>
                  </select>
                </div>
              </div>

             <div class="row form-group">
                  <div class="col">
                    <label v-if="isEnglish()==true" for="exampleFormControlSelect1">Select divisions</label>
                    <label v-if="isEnglish()==false" for="exampleFormControlSelect1">Sélectionner les divisions</label>
                    <v-select taggable multiple v-model="selected" :options="divisions" :close-on-select="false"/>
                  </div>
             </div>

            </form>
          </div>
          <div class="modal-footer">
            <button  v-if="isEnglish()==true" type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button  v-if="isEnglish()==true" type="button" class="btn btn-primary" v-on:click="change_invite_role()">Apply</button>
            <button  v-if="isEnglish()==false" type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
            <button  v-if="isEnglish()==false" type="button" class="btn btn-primary" v-on:click="change_invite_role()">Sauvegarder</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5  v-if="isEnglish()==true" class="modal-title" id="deleteModalLabel">Are you sure you want to delete {{invitee.email}} ?</h5>
            <h5  v-if="isEnglish()==false" class="modal-title" id="deleteModalLabel">Etes vous sure de vouloir supprimer {{invitee.email}} ?</h5>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>

              <div class="row form-group">
                <div class="col">
                  <div class="form-group">
                    <label for="exampleFormControlSelect1">Email</label>
                    <input type="text" v-model="invitee.email" class="form-control" disabled>
                  </div>
                </div>
              </div>

              <div class="row form-group">
                <div class="col">  <div class="form-group">
                  <label  v-if="isEnglish()==true" for="exampleFormControlSelect1">Company</label>
                  <label  v-if="isEnglish()==false" for="exampleFormControlSelect1">Compagnie</label>

                  <input type="text" v-model="invitee.company_name" class="form-control" disabled>
                </div></div>
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button  v-if="isEnglish()==true" type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
            <button  v-if="isEnglish()==true" type="button" class="btn btn-primary" data-dismiss="modal" v-on:click="delete_invite()">Yes</button>
           <button  v-if="isEnglish()==false" type="button" class="btn btn-secondary" data-dismiss="modal">Non</button>
            <button  v-if="isEnglish()==false" type="button" class="btn btn-primary" data-dismiss="modal" v-on:click="delete_invite()">Oui</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="resendModal" tabindex="-1" role="dialog" aria-labelledby="resendModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-if="isEnglish()==true" class="modal-title" id="resendModalLabel">Are you sure you want to send a new invitation to {{invitee.email}} ?</h5>
            <h5 v-if="isEnglish()==false" class="modal-title" id="resendModalLabel">Etes vous sur de vouloir envoyer une autre invitation á {{invitee.email}} ?</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>

              <div class="row form-group">
                <div class="col">
                  <div  v-if="failed" class="alert alert-danger" role="alert">
                    {{ msg }}
                  </div>
                  <div class="form-group">
                    <label for="exampleFormControlSelect1">Email</label>
                    <input type="text" v-model="invitee.email" class="form-control" disabled>
                  </div>
                </div>
              </div>

              <div class="row form-group">
                <div class="col">  <div class="form-group">
                  <label v-if="isEnglish()==true" for="exampleFormControlSelect1">Company</label>
                  <label v-if="isEnglish()==false" for="exampleFormControlSelect1">Compagnie</label>

                  <input type="text" v-model="invitee.company_name" class="form-control" disabled>
                </div></div>
              </div>

              <div class="row form-group">
                <div class="col">
                  <label v-if="isEnglish()==true" for="exampleFormControlSelect1">Select Role</label>
                  <label v-if="isEnglish()==false" for="exampleFormControlSelect1">Choisir Role</label>
                  <select class="form-control" v-model="invitee.role" id="exampleFormControlSelect1">
                    <option value="Basic">Basic</option>
                    <option value="Admin"> Admin</option>
                  </select>
                </div>
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button v-if="isEnglish()==true"  type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
            <button v-if="isEnglish()==true"  type="button" class="btn btn-primary"  v-on:click="send_invite()">Yes</button>
            <button v-if="isEnglish()==false" type="button" class="btn btn-secondary" data-dismiss="modal">Non</button>
            <button v-if="isEnglish()==false" type="button" class="btn btn-primary"  v-on:click="send_invite()">Oui</button>
          </div>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
  import DataService from "@/services/DataService";
  import SideMenu from './SideMenu.vue';

  export default {
    name: 'Invitations',
    components: {
    'side-menu': SideMenu
  },
    props: ['search_on','search_obj','language'],
    data () {
      return {
        invi_state:"active",
        msg: '',
        token :localStorage.getItem('token'),
        granted: false,
        failed:false,
        isSuper: false,
        company_id:'',
        user_email: localStorage.getItem('email'),
        no_company:'',
        lang : this.language,
        sent: false,
        caller_role:localStorage.getItem('caller_role'),
        users:[],
        companies:[],
        invitees:[],
        divisions:[],
        selected:[],
        invitee:{email:"",no_company:"",company_name:"",role:""},
        user:{ no_company:"",email:"",role_id:"",name:"",company_name:""},


      }
    },


    methods:{

      greet: function (item) {
        this.invitee.email = item.email;
        this.invitee.no_company = item.no_company;
        console.log("printing the company in the greet "+this.invitee.no_company  );
        this.invitee.role = item.role;
        console.log(item);

        this.get_company_name(item.no_company);
        this.get_company_divisions(this.invitee.no_company);
        this.get_invite_divisions(item.email,item.no_company);

      },


      delete_invite(){
        console.log("deleting a user");

        var dataa = {email:this.invitee.email};

        console.log(dataa);
        var token = this.$parent.token;
        DataService.delete_invite(dataa,token)
          .then(response => {

            console.log(response.data);
            //this.message = response.data.message;
            this.msg = this.$parent.translate_error_message(response.data,"message");;
            this.granted = true;

            this.users_list(this.$parent.token);


          })
          .catch(error => {
            console.log(error.response);
            //this.message = error.response.data.errors[0];
            //console.log(error.response.data.errors);
          });
      },


      get_company_name(param){
        var dataa = {no_company:param};
        this.failed = false;

        console.log("printing the dataa before sending");
        console.log(dataa);
        DataService.get_company_name(dataa)
          .then(response => {

            console.log(response.data);
            this.invitee.company_name = response.data.company_name;
            this.user.company_name = response.data.company_name

          })
          .catch(e => {
            console.log(e.response);
            if(e.response.status == 404){

              this.msg = "Route nod found";
            }else if(e.response.status == 500){
              this.msg = "Sorry , service unavailable at the moment , try again later.";
            }else if(e.response.status == 422){
              this.msg = this.$parent.translate_error_message(e.response.data.errors,"errors");
            }else {
              this.msg = "Please check your internet.";
            }

            this.failed = true;
          });
      },


      get_invite_divisions(param){
        var dataa = {email:param};
        var token = localStorage.getItem('token');
        this.failed = false;
        this.selected = [];

        console.log("printing the dataa before sending");
        console.log(dataa);
        DataService.get_invite_divisions(dataa,token)
          .then(response => {

            console.log(response.data);
             response.data.my_divisions.forEach(element => {
                var divis = {no_division:element.no_division,label:element.label};
                this.selected.push(divis);
            });

          })
          .catch(e => {
            console.log(e.response);
            if(e.response.status == 404){

              this.msg = "Route nod found";
            }else if(e.response.status == 500){
              this.msg = "Sorry , service unavailable at the moment , try again later.";
            }else if(e.response.status == 422){
              this.msg = this.$parent.translate_error_message(e.response.data.errors,"errors");
            }else {
              this.msg = "Please check your internet.";
            }

            this.failed = true;
          });
      },


      newModelOpened(){

      if(!this.isSuper){

         this.get_company_divisions(this.no_company);

      }

      },


      onCompanyChange(){

        console.log(this.invitee.no_company);
        this.get_company_divisions(this.invitee.no_company);

      },


      get_company_divisions(no_company){

          this.divisions=[];
          this.selected=[];
          this.sent = false; this.failed=false;
          var dataa = {no_company:no_company};

          console.log(dataa);
          var token = localStorage.getItem('token');
          DataService.get_company_divisions(dataa,token)
          .then(response => {

            response.data.divisions.forEach(element => {
              var divis = {no_division:element.no_division,label:element.label};
              this.divisions.push(divis);
            });

          })
          .catch(e => {
            console.log(e.response);


            if(e.response.status == 404){

              this.msg = "Route nod found";
            }else if(e.response.status == 500){
              this.msg = "Sorry , service unavailable at the moment , try again later.";
            }else if(e.response.status == 422){
              this.msg = this.$parent.translate_error_message(e.response.data.errors,"errors");
            }else {
              this.msg = "Please check your internet.";
            }

          });


      },


      check_error_field(error_message){
      //str.includes("world")
      
      },


      send_invite(){
        this.sent = false;

        if(this.isSuper){
              var dataa = {email:this.invitee.email,divisions:this.selected,no_company:this.invitee.no_company,role:this.invitee.role};
        }else{
               var dataa = {email:this.invitee.email,divisions:this.selected,no_company:this.no_company,role:this.invitee.role};
        }

        console.log(dataa);
        var token = this.$parent.token;
        this.sent = true;
        this.failed = false;
        DataService.invite_user(dataa,token)
          .then(response => {

            this.sent = false;
            console.log(response.data);
            //this.message = response.data.message;
            this.msg = this.$parent.translate_error_message(response.data,"message")
            $('#inviteModal').modal('hide');
            $('#resendModal').modal('hide');
            
            this.granted = true;
            this.users_list(localStorage.getItem('token'));


            //fredysallah@gmail.com

          })
          .catch(e => {
            console.log(e.response);
            this.sent = false;

            if(e.response.status == 404){

              this.msg = "Route nod found";
            }else if(e.response.status == 500){
              this.msg = "Sorry , service unavailable at the moment , try again later.";
            }else if(e.response.status == 422){
              this.msg = e.response.data.errors[0];

              this.$parent.eventmsg = this.msg;
              this.$parent.showeventmsg = false;
              this.$parent.showerrormsg = true;
              setTimeout(() => this.$parent.showerrormsg = false, 3000);

            }else {
              this.msg = "Please check your internet.";
            }
            this.failed = true;
          });
      },



      change_invite_role(){
        this.sent = false;
        var dataa = {email:this.invitee.email,role:this.invitee.role,divisions:this.selected};
        this.invitee.email="";this.invitee.no_company="";
        console.log(dataa);
        var token = this.$parent.token;
        this.sent = true;
        this.failed = false;
        DataService.change_invitation_role(dataa,token)
          .then(response => {

            this.sent = false;
            console.log(response.data);
            //this.message = response.data.message;
            this.msg = this.$parent.translate_error_message(response.data,"message");
            this.token = localStorage.getItem('token');
            this.users_list(this.token);
            $('#changeroleModal').modal('hide');
            this.granted = true;
            //this.users_list(this.$parent.token);


          })
          .catch(e => {
            console.log(e.response);
            this.sent = false;

            if(e.response.status == 404){

              this.msg = "Route nod found";
            }else if(e.response.status == 500){
              this.msg = "Sorry , service unavailable at the moment , try again later.";
            }else if(e.response.status == 422){
              this.msg = e.response.data.errors[0];
            }else {
              this.msg = "Please check your internet.";
            }
            this.failed = true;
          });
      },


      date_formatting(mysql_date){

        var date = new Date(mysql_date);

        return +date.getDate()+
          "/"+(date.getMonth()+1)+
          "/"+date.getFullYear()+
          " "+date.getHours()+
          ":"+date.getMinutes()+
          ":"+date.getSeconds();

      },



      users_list(token){

        var dataa = {};

        DataService.fetch_users_list(dataa,token)
          .then(response => {

            console.log(response.data);
            //this.message = response.data.message;

            this.users = response.data.users;
            this.companies = response.data.companies;
            this.invitees = response.data.invites;


             setTimeout(() => $('#myTable').DataTable(), 1000);

            if(response.data.super===false){
              this.company_id = response.data.no_company;
              this.no_company = response.data.no_company;
              this.invitee.company_id = response.data.company_id;
              console.log("printing the company of the logger "+this.no_company );
            }else if(response.data.super===true){
               this.isSuper = response.data.super;
            }

          })
          .catch(e => {
            console.log(e.response);
          if(e!=undefined){

           if(e.response.status == 404){

            this.msg = "Route nod found";
          }else if(e.response.status == 401){
             this.$router.push('/login');
          }else if(e.response.status == 500){
            this.msg = "Sorry , service unavailable at the moment , try again later.";
          }else if(e.response.status == 422){
            this.msg = this.$parent.translate_error_message(e.response.data.errors,"errors");
          }else {
            this.msg = "Please check your internet.";
          }
          this.failed = true;

          }

          });
      },

      isEnglish(){

            let lang = localStorage.getItem('lang');
            if(lang=='en'){

            return true;

            }else if(lang=='fr'){

            return false;

            }else{

            return true;

            }

      },


    },


    watch: {

      language:function(){
        this.lang = this.language;
        console.log("language value has changed in private component");
        //this.language = this.lang ;
      },

      search_on:function(){
        console.log("value of search_on is :"+this.search_on);


        if(this.search_on){

          //this.search_user_products(this.search_obj);
           //this.$parent.search_on = false;
           this.$router.push('/products');

        }

        console.log(this.search_obj);
      },

},


    created(){
      console.log("printimg loggedin value in created :"+this.$parent.loggedin);
      console.log("printimg token value in created :"+this.$parent.token);

    
      

    },



    mounted(){

      console.log("printimg loggedin value in invitation mounted :"+this.$parent.loggedin);
      console.log("printimg token value in invitation mounted :"+this.$parent.token);


      if(localStorage.getItem('token')=='' || localStorage.getItem('token')==null){

        this.$router.push('/login');
      }else{

        if(localStorage.getItem('caller_role')=='Basic'){
          this.$router.push('/login');

        }else{
          this.$parent.token = localStorage.getItem('token');
          this.token = localStorage.getItem('token');
          this.users_list(this.token);
        }

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /* @import './dassets/apple-touch-icon.png';
  @import './dassets/favicon.png';  */
  @import 'https://fonts.googleapis.com/css2?family=Work+Sans:wght@300;400;500;600;700&amp;display=swap';
  @import '../dassets/plugins/font-awesome/css/font-awesome.min.css';
  @import '../dassets/fonts/Linearicons/Font/demo-files/demo.css';
  @import '../dassets/plugins/bootstrap/css/bootstrap.min.css';
  @import '../dassets/plugins/owl-carousel/assets/owl.carousel.css';
  @import '../dassets/plugins/select2/dist/css/select2.min.css';
  @import '../dassets/plugins/summernote/summernote-bs4.min.css';
  @import '../dassets/plugins/apexcharts-bundle/dist/apexcharts.css';
  @import '../dassets/css/style.css';

  @import 'https://cdn.datatables.net/1.10.24/css/jquery.dataTables.min.css';

</style>



// WEBPACK FOOTER //
// src/components/Invitations.vue